import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import { useValue } from '@morningtrain/react-resources';
import { observer } from 'mobx-react';

function Html(props) {
  var name = props.name,
      defaultValue = props.defaultValue;
  var value = useValue(name, defaultValue);
  return /*#__PURE__*/React$1.createElement("div", {
    className: props.className,
    dangerouslySetInnerHTML: {
      __html: value
    }
  });
}

Html.defaultProps = {
  defaultValue: null,
  className: ''
};
Html.propTypes = {
  name: PropTypes$1.string.isRequired,
  defaultValue: PropTypes$1.any,
  className: PropTypes$1.string
};
var Html$1 = observer(Html);

export default Html$1;
//# sourceMappingURL=Html.js.map
